module.exports = __webpack_public_path__ + "24_vis.jpg?4fc083973732682845da4f801effc6bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_vis.jpg
// module id = 214
// module chunks = 0